// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
//import '../common/browser.min'
import 'babel-polyfill';
import 'babel-preset-es2015-ie'
import promise from 'es6-promise';
promise.polyfill();
import Vue from 'vue';
import App from './App';
import router from './router';
import store from './store/store';
import md5 from 'js-md5';
import zipJS from 'jszip';
import axios from 'axios';
import env from './config/dev';
/*import unZip from 'unzip';*/
//import base64 from 'js-base64';
import $ from 'jquery';
import jQuery from 'jquery';

/*  使用ElementUI */
import ElementUI from 'element-ui';
import {Select, Option, Dialog, Button, Table} from 'element-ui';
Vue.use(Select);
Vue.use(Option);
Vue.use(Dialog);
Vue.use(Button);
Vue.use(Table);
/*  国际化配置  */
import i18n from './i18n/i18n';
import locale from 'element-ui/lib/locale/lang/en';


/* 导入ElementUI css */
import 'element-ui/lib/theme-chalk/index.css'
import '@/assets/css/index/main-common.css';
// JS MD5

Vue.prototype.$md5 = md5;
Vue.prototype.$zip = zipJS;
/*Vue.Prototype.$unZip = unZip;*/
//Vue.prototype.$base64 = base64;
// axios 全局配置
/*import axios from '../api/login'*/
Vue.prototype.$http = axios;

// 导入全局助手函数
import  funcs from '../helpers/g_funcs';
Vue.prototype.helper = funcs;

//支持语言包
import options from './config/support.langs';
Vue.prototype.suplangs = options;

//海外、国内环境
Vue.prototype.$env = env;

Vue.use(ElementUI, {locale});

Vue.config.productionTip = true;

/* eslint-disable no-new */
new Vue({
    el: '#app',
    router,
    i18n,
    store,
    components: {App},
    template: '<App/>',
});



// WEBPACK FOOTER //
// ./src/main.js